import { create } from 'zustand';

const STORAGE_KEY = 'synq.activeProject';

interface ProjectState {
  activeProjectId: string | null;
  setActiveProject: (projectId: string | null) => void;
}

/**
 * Proyecto activo de la barra lateral. Se recuerda entre recargas para que al
 * volver la persona caiga en el mismo tablero que dejo abierto. Es una
 * preferencia local, no un dato de negocio, asi que localStorage basta.
 */
export const useProjectStore = create<ProjectState>((set) => ({
  activeProjectId: readStored(),

  setActiveProject(projectId) {
    set({ activeProjectId: projectId });
    try {
      if (projectId) {
        localStorage.setItem(STORAGE_KEY, projectId);
      } else {
        localStorage.removeItem(STORAGE_KEY);
      }
    } catch {
      // Modo privado o almacenamiento bloqueado: el proyecto sigue en memoria.
    }
  },
}));

function readStored(): string | null {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}
